import { render } from "./SignInPage.vue?vue&type=template&id=892a980c&ts=true"
import script from "./SignInPage.vue?vue&type=script&lang=ts"
export * from "./SignInPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__